module.exports = __webpack_public_path__ + "img/nav_bg.75ed8d8.webp";